interface BadgeImagesArray {
    [badgeName: string]: string;
}

const QualificationBadges: BadgeImagesArray = {
    lumina_spark: '/img/QualificationBadges/lumina-spark_qualified_badge.png',
    lumina_emotion: '/img/QualificationBadges/lumina-emotion_qualified_badge.png',
    lumina_sales: '/img/QualificationBadges/lumina-sales_qualified_badge.png',
    lumina_select: '/img/QualificationBadges/lumina-select_qualified_badge.png',
    lumina_leader: '/img/QualificationBadges/lumina-leader_qualified_badge.png',
    manager_as_coach: '/img/QualificationBadges/manager-coach_qualified_badge.png',
};

export default QualificationBadges;
